import { useLogin  } from '@/js/auth.js'

import { createRouter, createWebHistory } from 'vue-router'

import DashboardView from '@/views/DashboardView.vue'
import LocationsView from '@/views/LocationsView.vue'
import DevicesView from '@/views/DevicesView.vue'
import SoundsView from '@/views/SoundsView.vue'
import SoundDetailsView from '@/views/SoundDetailsView.vue'
import SettingsView from '@/views/SettingsView.vue'
import AboutView from '@/views/AboutView.vue'
import LoginView from '@/views/LoginView.vue'
import EditorView from '@/views/EditorView.vue'


const routes = [
    {
        path: '/',
        name: 'root',
        component: SoundsView,
        meta: { requiresAuth: true },
    },
    {
        path: '/sounds',
        name: 'soundsPage',
        component: SoundsView,
        meta: { requiresAuth: true },
    },
    {
        path: '/sounds/:id',
        name: 'soundDetailsPage',
        component: SoundDetailsView,
        meta: { requiresAuth: true },
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
    },
    {
	path: '/login/:stage',
	name: 'loginstage',
	component: LoginView,
        props: true,
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: DashboardView,
        meta: { requiresAuth: true },
    },
    {
        path: '/locations',
        name: 'locations',
        component: LocationsView,
        meta: { requiresAuth: true },
    },
    {
        path: '/devices',
        name: 'devices',
        component: DevicesView,
        meta: { requiresAuth: true },
    },
    {
        path: '/settings',
        name: 'settings',
        component: SettingsView,
        meta: { requiresAuth: true },
    },
    {
        path: '/about',
        name: 'about',
        component: AboutView,
        meta: { requiresAuth: true },
    },
    {
        path: '/editor',
        name: 'editor',
        component: EditorView,
        meta: { requiresAuth: true },
    }
]


const router = createRouter({
    history: createWebHistory(),
    routes
})


router.beforeEach(async (to, from) => {
    const store = useLogin()
    const isLogged = store.isLogged
    if (process.env.VUE_APP_AUTH_ENABLED == "true" && to.meta.requiresAuth && !isLogged()) {
        if (to.name != "login" || to.name != "loginstage"){
            console.log("router: redirecting...")
            return {name: "login"}
        }
    }
})


export default router
